import { ComponentParams, ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import { SpecCheckProps } from '../types/specCheck.types';

export class SpecCheckModel {
  private readonly params: ComponentParams | undefined;
  private readonly rendering?: ComponentRendering;

  constructor(props: SpecCheckProps) {
    this.params = props?.params;
    this.rendering = props?.rendering;
  }

  get componentName(): string {
    return this.rendering?.componentName || '';
  }

  get embedId(): string | undefined {
    return this.params?.embedId;
  }
}
